module.exports = __webpack_public_path__ + "img/farms.9476358a.png";